﻿// Generique
import Page = require("./components/Page");
//import DefaultEdit = require("./components/DefaultEdit");
// import DefaultSearchBox = require("./components/DefaultSearchBox");
// import DefaultSearchBoxExtension = require("./components/DefaultSearchBoxExtension");
// import DefaultTransfertSearchBoxes = require("./components/DefaultTransfertSearchBoxes");
// Specifique
import Portail = require("./components/Portail");
import PortailSecurite = require("./components/PortailSecurite");
// import DeclarationPalier = require("./components/DeclarationPalier");
// import DeclarationPalierSecurite = require("./components/DeclarationPalierSecurite");

export = {
    //== Generic components
    Page,
    //DefaultEdit,
    // DefaultSearchBox,
    // DefaultSearchBoxExtension,
    // DefaultTransfertSearchBoxes,
    //== Custom components
    Portail,
    PortailSecurite
};
